import axios from "axios";
import { API_URL } from "../../const";

export const getAttendance = (statusData: any) => {
  const data = {
    GetUserAttendanceToken: statusData,
  };
  const url = `${API_URL}FetchUserAttendanceDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

export const updateAttendanceCall = async (statusData: any) => {
  const data = {
    UpdateAttendanceToken: statusData,
  };
  const url = `${API_URL}UpdateAttendance`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

// Download Attendance
export const downloadAttendanceCall = async (statusData: any) => {
  const data = {
    GetAttendanceToken: statusData,
  };
  const url = `${API_URL}FetchAttendanceDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

/** *************** END EXPORT CALL BACK  DETAILS ***************** */
export const ComonExportPage = (fetchData: JSON) => {
  const data = {
    CreateRequestReportToken: fetchData,
  };

  const url = `${API_URL}CreateRequestReport`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
